var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"simulador-express"}},[_c('vx-card',{staticClass:"mb-6"},[_c('div',{staticClass:"vx-row"},[_c('div',{staticClass:"vx-col w-full"},[_c('h1',{staticClass:"rg-big-title extrabold rg-title"},[_vm._v("Simulador "),_c('span',{staticClass:"orange"},[_vm._v("Express")]),_vm._v(".")])])])]),_c('express-simulator')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }